import { render, staticRenderFns } from "./section-acum.vue?vue&type=template&id=0bfea3a1&scoped=true"
import script from "./section-acum.vue?vue&type=script&lang=js"
export * from "./section-acum.vue?vue&type=script&lang=js"
import style0 from "./section-acum.vue?vue&type=style&index=0&id=0bfea3a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfea3a1",
  null
  
)

export default component.exports